<style lang="less" scoped>

</style>

<template lang="pug">
  .dialog-content-cover
    form(action="#" method="post" @submit.prevent="addPrescription()")
      div(style="margin-bottom: 16px;")
        el-input(type="text" v-model="name" placeholder="이름 입력")
      div
        el-button.w10(type="success" native-type="submit") 처방 추가
</template>

<script>
export default {
  data() {
    return {
      name: null,
    };
  },
  methods: {
    addPrescription() {
      if (!this.name) {
        alert('처방 이름을 반드시 기입하셔야 합니다.');
        return false;
      }
      this.$emit('addPrescription', this.name);
      return true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modal/modal_recipe_name_input.vue